export { getStaticPropsNotFoundPage } from './lib'
export { NotFoundPage } from './ui'
export type { TNotFoundPageData } from './types'
